import { Check } from "lucide-react";

const STEPS = ["Document", "Extracted Transactions", "Review & Correct", "Validate", "Analyze", "Export"];

export const Stepper = ({ current, onStep }) => (
  <div className="rounded-lg border border-border bg-white p-4" data-testid="workflow-stepper">
    <ol className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-2">
      {STEPS.map((label, i) => {
        const n = i + 1;
        const done = n < current;
        const active = n === current;
        return (
          <li key={label} className="flex flex-1 items-center gap-2">
            <button onClick={() => onStep?.(n)} data-testid={`step-${n}`}
                    className={`flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors duration-200 ${
                      active ? "bg-primary text-primary-foreground"
                             : done ? "bg-secondary text-secondary-foreground"
                                    : "bg-muted text-muted-foreground hover:text-foreground"}`}>
              <span className="grid h-5 w-5 place-items-center rounded-full border border-current text-[10px]">
                {done ? <Check className="h-3 w-3" /> : n}
              </span>
              <span className="whitespace-nowrap">{label}</span>
            </button>
            {i < STEPS.length - 1 && <span className="hidden h-px flex-1 bg-border sm:block" />}
          </li>
        );
      })}
    </ol>
  </div>
);
